{
  "title": "Create Goal",

  "basics": {
    "createGoalFor": "Create Goal for {{whom}}",
    "household": "Household",
    "corporation": "Corporation",
    "applyPortfolioAtGoal": "Apply portfolio at goal"
  },
  "pickPortfolio": {
    "applyPortfolio": "Apply Portfolio",
    "useTheScores": "Use the suitability scores to help select the optimal risk level for the portfolio.",
    "goalSuitabilityScore": "Goal Suitability Score",
    "someonesSuitabilityScore": "{{name}}'s Suitability Score"
  },
  "recommendedPortfolio": "Recommended portfolio model",
  "goalSummary": "Goal Summary",
  "pleaseReview": "Please review your information to ensure it’s correct. You can edit this later under Goals.",
  "continue": "Continue",
  "createGoal": "Create Goal",
  "added": "You've created a new goal",
  "failed": "Adding a new goal failed.",
  "subAccMsg": "Let's connect this goal to a sub-account",
  "createSubAccount": "Create Sub-account",
  "skipforNow": "Skip for now",
  "tradingProcess": "Trading Process"
}
